export default {"src":"/_next/static/media/DocumentsIconCategoryActive.0a721ca4.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};